/*
 * Detect when zepto loads into page
 */

 document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded and parsed");

    function whenAvailable(DOM_element, callback, number_of_trys = 0) {
        number_of_trys += 1;
        const appEl = document.querySelector(DOM_element)
        const interval = 1000; 
    
        //console.log( number_of_trys)
        const int = window.setTimeout(function() {
            if (appEl) {
                callback(appEl);
                clearInterval(int)
            } else {
            console.log(`Waiting for DOM ENGRAVING MODAL ELEMENT ${DOM_element} to be available...`);
            number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys DOM ENGRAVING MODAL ELEMENT", number_of_trys);
            }
        }, interval);
    }
        
    whenAvailable(".btn.pplr-c-button", function(el) {
        console.log("Zepto script loaded");
      
        // zepto blue button
        el.addEventListener('click', function(){
          console.log("rebind")
          bindZeptoFormToCart()
        })
      
        // CTA 'Click here to add ...'
        // NOTE: inputs nodes from function bindZeptoFormToCart are duplicate due click spreading behaviour, functionallity works as expected
        const personalizeItCTAtext = document.querySelector('[data-js="zepto-trigger"]');
        console.log("Personalize It CTA Text:", personalizeItCTAtext);
        
        if (personalizeItCTAtext) {
            personalizeItCTAtext.addEventListener('click', function () {
                console.log("Zepto trigger clicked");
                el.click(); // Trigger the modal opening

               // bind size dropdown value to zepto form
               bindZeptoFormToCart()

              // zepto ui - checkbox 
              // setTimeout(()=>{
              //   const modal_close = document.querySelector('.js-modal-close')
              //   console.log('modal_close', modal_close)
              //   if(!modal_close){
              //     return console.log('Cant find zepto modal clos button')
              //   }

              //   modal_close.addEventListener('click', ()=>{
              //     personalizeItCTAtext.checked = false;
              //   }) 
              // },2000)
            });


        } else {
            console.error("Zepto trigger element not found");
        }

        // Add an Engraving to this cane - collapsible tab
        const tab_trigger = document.querySelector('[href="#open-zepto"]')
        if(tab_trigger){
           tab_trigger.addEventListener('click', function (e) {
                e.preventDefault()
                el.click(); 
            });
        }
    });

    // bind sizing dopdown values to zepto forms
    function bindZeptoFormToCart(){
      whenAvailable('.pplr_form.pplr_atc_form', function(zeptoForm) {
        console.log(zeptoForm)
  
        
          const lengthSelect = document.querySelector("[data-js='select-length']");
          if(!lengthSelect){
            return console.log('Cant find lengthSelect for engraving zepto form')
          }
          console.log(lengthSelect.value)
  
          const inputLength = document.createElement('input')
          inputLength.type = 'hidden'
          inputLength.value = lengthSelect.value
          inputLength.setAttribute('name', 'properties[*Length*]')
  
          const inputDefault =  document.querySelector("[name='properties[_CANE-DEFAULT-SIZE-TAG]']")
          const inputDefaultValue = inputDefault.cloneNode();
  
          zeptoForm.insertBefore(inputLength, null)
          zeptoForm.insertBefore(inputDefaultValue, null)
        })
    }


});